
import './style.scss'

interface LabeledInputProps {
	label?: string
	onChange: (newValue: string) => void
	onBlur?: () => void
	value?: string
	type?: string
	disabled?: boolean
}

function LabeledInput({label, onChange, onBlur, value, type, disabled}: LabeledInputProps) {
	
	const valueChangeHandler = (newValue: string) => {
		onChange(newValue)
	}

	return (
		<div className='labeled-input-wrap'>
			{label && 
				<span className='labeled-input-label'>{label}</span>
			}
			<input
				className='labeled-input-input'
				type={type ? type : 'text'}
				value={value}
				onChange={(event) => {
					valueChangeHandler(event.target.value)
				}}
				onBlur={onBlur}
				disabled={disabled}
			/>
		</div>
	)
}

export default LabeledInput